import { render, staticRenderFns } from "./statusResult.vue?vue&type=template&id=2671d254&scoped=true&"
import script from "./statusResult.vue?vue&type=script&lang=ts&"
export * from "./statusResult.vue?vue&type=script&lang=ts&"
import style0 from "./statusResult.vue?vue&type=style&index=0&id=2671d254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671d254",
  null
  
)

export default component.exports